import { SVGProps, Ref, forwardRef } from 'react';

export const SendIosFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.333 16C1.333 8.667 5 1.333 16 1.333S30.667 8.667 30.667 16 27 30.667 16 30.667 1.333 23.333 1.333 16M17.2 12.893v10.44h-2.4v-10.44l-3.952 3.951-1.697-1.697 6-6L16 8.298l.849.849 6 6-1.698 1.697z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SendIosFilledSize32Glyph.displayName = 'SendIosFilledSize32Glyph';
